var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { display: "contents" } }, [
    _c("canvas", {
      ref: "pdfPreview",
      staticClass: "pdfViewer object-fit-cover position-absolute t-0 l-0",
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }